import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { reactHookForm, designSystem, Modal, PanelGroup, Panel } from '@yola/ws-ui';
import { MAX_FOLDER_NAME_CHARS } from '../constants';

const { useForm } = reactHookForm;
const {
  ControlGroup,
  InputGroupField,
  DialogHeader,
  DialogHeaderTitle,
  DialogButtonGroup,
  DialogButton,
  DialogButtonGroupSeparator,
  Box,
} = designSystem;

const MODAL_WIDTH = 334;
const FIELD_NAME = 'folderName';

function FolderSettingsDialog({ defaultFolderName, onSubmit, onCancel, captions }) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      [FIELD_NAME]: defaultFolderName,
    },
  });

  const handleDialogSubmit = (values) => {
    onSubmit(values[FIELD_NAME].trim());
  };

  return (
    <Modal
      width={MODAL_WIDTH}
      height="auto"
      overlay="visible"
      resizable={false}
      draggable={false}
      centered
      handleSubmit={handleSubmit(handleDialogSubmit)}
      handleCancel={onCancel}
      onOverlayClick={onCancel}
      onPressEsc={onCancel}
      onPressEnter={handleSubmit(handleDialogSubmit)}
    >
      <PanelGroup height="100%">
        <Panel align="middle" theme="gray-100" corners="squared" height="100%">
          <DialogHeader>
            <DialogHeaderTitle>{captions.title}</DialogHeaderTitle>
          </DialogHeader>
        </Panel>
        <Panel className="ws-without-border-bottom">
          <Box
            paddingTop="spacing-s"
            paddingLeft="spacing-m"
            paddingRight="spacing-m"
            paddingBottom="spacing-m"
          >
            <ControlGroup title={captions.folderNameLabel} required>
              <InputGroupField
                control={control}
                name={FIELD_NAME}
                maxLength={MAX_FOLDER_NAME_CHARS}
                rules={{
                  required: i18next.t('This field is required'),
                  maxLength: {
                    value: MAX_FOLDER_NAME_CHARS,
                    message: i18next.t(`Maximum number of characters {number}`, {
                      number: MAX_FOLDER_NAME_CHARS,
                    }),
                  },
                }}
              />
            </ControlGroup>
          </Box>
        </Panel>
        <Panel>
          <DialogButtonGroup rounded>
            <DialogButton onClick={handleSubmit(handleDialogSubmit)}>
              {captions.submit}
            </DialogButton>
            <DialogButtonGroupSeparator />
            <DialogButton stretch="block" size="large" onClick={onCancel}>
              {captions.cancel}
            </DialogButton>
          </DialogButtonGroup>
        </Panel>
      </PanelGroup>
    </Modal>
  );
}

FolderSettingsDialog.propTypes = {
  defaultFolderName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    folderNameLabel: PropTypes.string.isRequired,
    submit: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
  }).isRequired,
};

export default FolderSettingsDialog;
